module.exports = __webpack_public_path__ + "media/800-4_SERF_2022_EmailRedFlags.a7db6a76.mp4";